<div class="trigger">
  <app-popup-top-line></app-popup-top-line>
  <div class="title-row">
    <div class="title">{{ 'playbooks.trigger' | labelsProvider }}</div>
    <img src="assets/images/common/cancel.svg" (click)="closeWindow()" />
  </div>
  <div class="separator"></div>
  <div class="content">
    <div class="left">
      <div class="title">
        {{ 'playbooks.trigger' | labelsProvider }}
        {{ 'common.list' | labelsProvider }}
      </div>
      <div
        class="trigger-option"
        *ngFor="let option of typesOptions"
        [ngClass]="{ selected: option.type === selectedType }"
        (click)="typeOnSelection(option.type)"
      >
        <div class="trigger-option-title">{{ option.name }}</div>
        @if (option.type === selectedType) {
          <img class="trigger-option-selected" src="assets/images/common/selected.svg" />
        }
      </div>
    </div>
    <div class="right">
      <div class="title">
        {{ 'playbooks.trigger' | labelsProvider }}
        {{ 'common.settings' | labelsProvider }}
      </div>

      @if (selectedType === supportedTypes.newViolationFound) {
        <div class="right__content">
          <app-new-violation-trigger
            [fg]="fg"
            [playbooksTriggerInput]="triggerFormInput"
            (validConfiguration)="setFormValidation($event)"
            class="new-violation-trigger"
          >
          </app-new-violation-trigger>

          <div class="buttons-container buttons-container-violations">
            <div class="btns">
              <div class="cancel" (click)="closeWindow()">
                {{ 'common.cancel' | labelsProvider }}
              </div>
              @if (isConfigurationValid()) {
                <div class="confirm" (click)="createOrUpdate()" cdkFocusInitial>
                  <span>{{ isEdit ? ('common.save' | labelsProvider) : ('common.create' | labelsProvider) }}</span>
                </div>
              } @else {
                <div class="confirm confirm-disabled" cdkFocusInitial>
                  <span>{{ isEdit ? ('common.save' | labelsProvider) : ('common.create' | labelsProvider) }}</span>
                </div>
              }
            </div>
          </div>
        </div>
      }

      @if (selectedType === supportedTypes.newResourceFound) {
        <div class="right__content">
          <app-new-resource-trigger
            [fg]="fg"
            [playbooksTriggerInput]="triggerFormInput"
            (validConfiguration)="setFormValidation($event)"
            class="new-resource-trigger"
          >
          </app-new-resource-trigger>

          <div class="buttons-container buttons-container-resources">
            <div class="description-tooltip">
              <app-supported-resource-types-tooltip
                [resourceTypeOptions$]="resourceTypeOptions$"
              ></app-supported-resource-types-tooltip>
            </div>

            <div class="btns">
              <div class="cancel" (click)="closeWindow()">
                {{ 'common.cancel' | labelsProvider }}
              </div>
              @if (isConfigurationValid()) {
                <div class="confirm" (click)="createOrUpdate()" cdkFocusInitial>
                  <span>{{ isEdit ? ('common.save' | labelsProvider) : ('common.create' | labelsProvider) }}</span>
                </div>
              } @else {
                <div class="confirm confirm-disabled" cdkFocusInitial>
                  <span>{{ isEdit ? ('common.save' | labelsProvider) : ('common.create' | labelsProvider) }}</span>
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
